import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

@Component({
  selector: 'ndms-logoff-timer',
  templateUrl: './logoff-timer.component.html',
  styleUrls: ['./logoff-timer.component.css']
})
export class LogoffTimerComponent {
  @Input() set counter(value: number) {
    this.seconds = value.toString();
  };

  @Output() logout = new EventEmitter<void>();
  @Output() continue = new EventEmitter<void>();

  seconds: string;
  iconBase: string = "";

  constructor(
    @Inject('BASE_URL') public baseUrl: string,
    @Inject('AGENCY_LOGO') public agencyLogo: string,
    @Inject('DEPARTMENT_LOGO') public departmentLogo: string) {
    this.iconBase = this.baseUrl;
  }
  
  onContinueClick() {
    this.continue.emit();
  }

  onLogoutClick() {
    this.logout.emit();
  }

}
